import { Fragment, type ReactNode } from "react";
import { cn } from "@/lib/utils";
import { SERIES_BG, TRACK_BG } from "./opsColors";

/** Label | bar | count rows. `centered` draws a funnel; `segments` splits one bar into parts. */
export function HBars({ rows, centered = false, footer }: {
  rows: { label: string; value: number; muted?: boolean; segments?: { value: number; className: string }[] }[];
  centered?: boolean;
  footer?: ReactNode;
}) {
  const max = Math.max(1, ...rows.map((r) => r.value));
  return (
    <div className="grid grid-cols-[auto_1fr_auto] items-center gap-x-2.5 gap-y-1 px-3 py-2 text-xs">
      {rows.map((r) => {
        const parts = (r.segments ?? [{ value: r.value, className: r.muted ? "bg-muted-foreground/40" : SERIES_BG }]).filter((s) => s.value > 0);
        return (
          <Fragment key={r.label}>
            <span className="text-muted-foreground whitespace-nowrap">{r.label}</span>
            <span className={cn("h-2.5 flex gap-[2px] rounded-sm", centered ? "justify-center" : TRACK_BG)} title={`${r.label}: ${r.value}`}>
              {parts.map((s, i) => (
                <span key={i} className={cn("h-full rounded-sm", s.className)} style={{ width: `${(s.value / max) * 100}%` }} />
              ))}
            </span>
            <span className="font-semibold tabular-nums text-right">{r.value}</span>
          </Fragment>
        );
      })}
      {footer && <div className="col-span-3 text-[11px] text-muted-foreground pt-1">{footer}</div>}
    </div>
  );
}
